import { render, staticRenderFns } from "./InsuranceSkladUsaTable.vue?vue&type=template&id=6ce541a2&scoped=true"
import script from "./InsuranceSkladUsaTable.vue?vue&type=script&lang=js"
export * from "./InsuranceSkladUsaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce541a2",
  null
  
)

export default component.exports